import React, { useCallback, useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { PackagingPOTable } from 'components/packaging/components/packagingPOV2/PackagingPOTable';
import { usePackagingPurchaseOrders } from 'components/packaging/components/packagingPOV2/queries/PackagingPOQueries';
import { UserContext } from 'contexts/UserContext';
import { Button } from 'shadcn/components/ui/Button';

export function ViewPackagingPOV2() {
    const history = useHistory();
    const user = useContext(UserContext);
    const facilityID = user?.getFacilityID?.();
    const statusFilter = '';

    const purchaseOrdersQuery = usePackagingPurchaseOrders({
        status: statusFilter,
        facilityID,
    });

    const { data, error, isFetching, isLoading } = purchaseOrdersQuery;
    const rows = useMemo(() => (Array.isArray(data) ? data : []), [data]);
    const errorMessage = error?.message ?? '';

    const handleCreatePurchaseOrder = useCallback(() => {
        history.push('/packaging/createPurchaseOrder-v2');
    }, [history]);

    const handleBulkCreatePurchaseOrders = useCallback(() => {
        history.push('/packaging/bulkCreatePurchaseOrders-v2');
    }, [history]);

    return (
        <div className="flex min-h-screen flex-col">
            <div className="px-4 pt-4">
                <div className="flex items-center justify-between">
                    <h1 className="text-xl font-semibold">Packaging Purchase Orders V2</h1>
                    <div>
                        <Button size="sm" className="mr-2" onClick={handleBulkCreatePurchaseOrders}>
                            Bulk Create Purchase Orders
                        </Button>
                        <Button size="sm" onClick={handleCreatePurchaseOrder}>
                            Create Purchase Order
                        </Button>
                    </div>
                </div>
            </div>
            <div className="flex flex-1 flex-col px-4 pb-6 pt-4">
                {errorMessage ? (
                    <div className="mb-4 rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive">
                        {errorMessage}
                    </div>
                ) : null}
                <PackagingPOTable data={rows} isFetching={isFetching} isLoading={isLoading} />
            </div>
        </div>
    );
}

ViewPackagingPOV2.displayName = 'ViewPackagingPOV2';
